import React from 'react';
import ProgramRouteCards from '../programs/ProgramRouteCards';

export default function ProgramsPreview() {
  return (
    <section className="py-20 md:py-24" data-testid="home-programs-preview">
      <div className="max-w-7xl mx-auto px-6">
        <div className="max-w-2xl mb-12">
          <div className="uppercase tracking-widest text-splash-coral text-xs font-semibold mb-3">Programs by Age</div>
          <h2 className="font-display font-bold text-4xl md:text-5xl text-splash-green leading-tight">Find the right fit for your swimmer</h2>
          <p className="mt-4 text-splash-green/75">Pick your child&rsquo;s age to see exactly what the program looks like, what it costs, and how to enroll.</p>
        </div>
        <ProgramRouteCards testIdPrefix="home-route-card" />
      </div>
    </section>
  );
}
